import React from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'

const StyledFilledButton = styled.button`
  padding: 10px 16px;
  background-color: ${colours.aqua};
  color: ${colours.darkPurple};
  font-weight: 600;
  border: none;
  transition: background-color 0.6s linear;
  &:hover {
    background-color: ${colours.aquaDarker};
  }
`

const StyledFilledLink = styled.a`
  display: inline-block;
  text-align: center;
  border-radius: 0.25rem;
  padding: 10px 16px;
  background-color: ${colours.aqua};
  color: ${colours.darkPurple};
  font-weight: 600;
  border: none;
  transition: background-color 0.6s linear;
  &:hover {
    color: ${colours.darkPurple};
    text-decoration: none;
    background-color: ${colours.aquaDarker};
  }
`

interface IProps {
  fontSize?: string
  onClick?: any
  children: any
  disabled?: boolean
  fullWidth?: boolean
  useLink?: boolean
  href?: string
}

class FilledButton extends React.Component<IProps> {
  static defaultProps: { onClick: () => void; href: string }

  render() {
    const { fontSize, onClick, children, disabled, fullWidth, useLink, href } = this.props
    const style = {
      fontSize: fontSize ? fontSize : 'inherit',
      width: fullWidth ? '100%' : 'auto'
    }
    if (useLink) {
      return (
        <StyledFilledLink href={href} onClick={onClick} style={style} target="_blank" rel="noreferrer noopener">
          {children}
        </StyledFilledLink>
      )
    } else {
      return (
        <StyledFilledButton onClick={onClick} disabled={!!disabled} style={style} className="btn">
          {children}
        </StyledFilledButton>
      )
    }
  }
}

FilledButton.defaultProps = {
  onClick: () => {},
  href: ''
}

export default FilledButton
